import { useEffect, useState } from "react";
import { useParams, useLocation } from "wouter";
import {
  TextInput,
  Checkbox,
  NumberInput,
  Button,
  Container,
  Title,
  Group,
  Textarea,
  ActionIcon,
  TagsInput,
  Stack,
} from "@mantine/core";
import { getStyle, createStyle, updateStyle } from "../../api";
import { notifications } from "@mantine/notifications";
import { IconTrash } from "@tabler/icons-react";
import { useForm } from "@mantine/form";
import { randomId } from "@mantine/hooks";

export default function AdminStyleForm() {
  const { id } = useParams();
  const [, setLocation] = useLocation();
  const isNewStyle = !id;

  useEffect(() => {
    if (!isNewStyle) {
      // Fetch the style data using the id for editing
      // Replace this with your actual API call
      getStyle(id).then((data) => {
        console.debug("Got style data:", data);
        form.setValues(data);
      });
    }
  }, [id, isNewStyle]);

  const handleSubmit = (values) => {
    // e.preventDefault();
    console.debug("handleSubmit invoked with:", values);
    // Submit the new or updated style
    // Replace this with your actual API call
    const apiCall = isNewStyle ? createStyle : updateStyle;
    apiCall(values).then(() => {
      notifications.show({
        title: "Style saved",
        message: "Your style has been saved successfully",
        color: "teal",
      });
      setLocation("/admin/styles");
    });
  };

  const form = useForm({
    mode: "uncontrolled",
    initialValues: {
      title: "",
      prompt: "",
      alias: "",
      isFeatured: false,
      order: 0,
      isPublic: false,
      loras: [],
      tags: [],
    },
  });

  const loraFields = form.getValues().loras.map((item, index) => (
    <Group key={item.key} align="center" mb="md">
      <TextInput
        style={{ flex: 1 }}
        label="Path"
        key={form.key(`loras.${index}.path`)}
        {...form.getInputProps(`loras.${index}.path`)}
        required
      />
      <NumberInput
        label="Scale"
        key={form.key(`loras.${index}.scale`)}
        {...form.getInputProps(`loras.${index}.scale`)}
        required
        min={0}
        step={0.1}
        precision={2}
      />
      <ActionIcon
        variant="subtle"
        onClick={() => form.removeListItem("loras", index)}
        color="red"
      >
        <IconTrash size={22} stroke={1.5} />
      </ActionIcon>
    </Group>
  ));

  return (
    <Container>
      <Title order={2}>{isNewStyle ? "Create New Style" : "Edit Style"}</Title>

      <form onSubmit={form.onSubmit((values) => handleSubmit(values))}>
        <Stack>
          <TextInput
            label="Id"
            disabled
            key={form.key("id")}
            {...form.getInputProps("id")}
          />
          <TextInput
            label="Title"
            required
            key={form.key("title")}
            {...form.getInputProps("title")}
          />
          <TextInput
            label="Alias"
            key={form.key("alias")}
            {...form.getInputProps("alias")}
          />
          <Textarea
            minRows={3}
            autosize
            label="Prompt"
            key={form.key("prompt")}
            {...form.getInputProps("prompt")}
          />
          <Textarea
            minRows={3}
            autosize
            label="Teaser"
            key={form.key("teaser")}
            {...form.getInputProps("teaser")}
          />
          <TagsInput
            label="Tags"
            key={form.key("tags")}
            {...form.getInputProps("tags")}
          />
          <Checkbox
            label="Is Public"
            key={form.key("isPublic")}
            {...form.getInputProps("isPublic", { type: 'checkbox' })}
          />
          <NumberInput
            label="Order"
            key={form.key("order")}
            {...form.getInputProps("order")}
          />
          <Checkbox
            label="Is Featured"
            key={form.key("isFeatured")}
            {...form.getInputProps("isFeatured", { type: 'checkbox' })}
          />
          <Title order={3}>Loras</Title>
          {loraFields}
          <Button
            onClick={() =>
              form.insertListItem("loras", {
                path: "",
                scale: 1.0,
                key: randomId(),
              })
            }
            mb="md"
          >
            Add Lora
          </Button>
          <Group>
            <Button type="submit">
              {isNewStyle ? "Create Style" : "Save Changes"}
            </Button>
            <Button
              onClick={() => setLocation("/admin/styles")}
              variant="outline"
            >
              Cancel
            </Button>
          </Group>
        </Stack>
      </form>
    </Container>
  );
}
